'use strict';

(function ($) {
  $.fn.k2_deserialize = function (data) {
    var _this = this;
    var map = {};

    var find = function (selector) {
      return _this.is('form') ? _this.find(selector) : _this.filter(selector);
    };

    //Get map of values
    $.each(data.split('&'), function () {
      var nv = this.split('=');
      var n = decodeURIComponent(nv[0]);
      var v = nv.length > 1 ? decodeURIComponent(nv[1]) : null;

      if (!(n in map)) {
        map[n] = [];
      }

      map[n].push(v);
    });

    //Set values for all form elements in the data
    $.each(map, function (n, v) {
      find('[name="' + n + '"]').val(v);
    });

    //Clear all form elements not in form data
    find('input:text,select,textarea').each(function () {
      if (!($(this).attr('name') in map)) {
        $(this).val('');
      }
    });

    find('input:checkbox:checked,input:radio:checked').each(function () {
      if (!($(this).attr('name') in map)) {
        this.checked = false;
      }
    });

    return _this;
  };
})(jQuery);
